(() => {
  const root = document.getElementById('cb-personalized-customizer');
  if (!root) return;
  const photoCount = Number(root.dataset.photoCount || 1);
  const variantId = root.dataset.variant || '';
  const isPlaid = root.dataset.plaid === 'true';
  const isPuzzle = root.dataset.puzzle === 'true';
  const isAcrylic = root.dataset.acrylic === 'true';
  const isKeychain = root.dataset.keychain === 'true';
  const isPhotoOnly = root.dataset.photoOnly === 'true';
  const acrylicVariants = isAcrylic ? JSON.parse(root.querySelector('[data-cb-acrylic-variants]')?.textContent || '[]') : [];
  const puzzleVariants = isPuzzle ? JSON.parse(root.querySelector('[data-cb-puzzle-variants]')?.textContent || '[]') : [];
  const plaidVariants = isPlaid ? JSON.parse(root.querySelector('[data-cb-variants]')?.textContent || '[]') : [];
  const detailPrice = document.querySelector('[data-cb-detail-price]');
  const mainPhoto = document.querySelector('[data-cb-main-photo]');
  const gallery = [...document.querySelectorAll('[data-cb-gallery-color]')];
  const puzzleGallery = [...document.querySelectorAll('[data-cb-gallery-puzzle]')];
  const money = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'});
  function showPlaidColor(color) {
    const chosen = gallery.find(button => button.dataset.cbGalleryColor === color);
    if (!chosen || !mainPhoto) return;
    mainPhoto.src = chosen.dataset.cbGallerySrc;
    mainPhoto.alt = chosen.dataset.cbGalleryAlt || 'Le Plaid Mémoire ' + color;
    gallery.forEach(button => button.setAttribute('aria-pressed', String(button === chosen)));
  }
  gallery.forEach(button => button.addEventListener('click', () => {
    const first = states[0];
    if (first?.colorSelect && !first.added && !busy) {
      first.colorSelect.value = button.dataset.cbGalleryColor;
      first.colorSelect.dispatchEvent(new Event('change', {bubbles: true}));
    } else {
      showPlaidColor(button.dataset.cbGalleryColor);
    }
  }));
  puzzleGallery.forEach(button => button.addEventListener('click', () => {
    if (!mainPhoto) return;
    mainPhoto.src = button.dataset.cbGallerySrc;
    mainPhoto.alt = button.dataset.cbGalleryAlt || 'Exemple de puzzle personnalisé';
    puzzleGallery.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));
  function getAcrylicVariant(state) {
    if (!state.sizeSelect) return null;
    return acrylicVariants.find(variant => String(variant.size) === state.sizeSelect.value && variant.available);
  }
  function updateAcrylicVariant(state) {
    if (!isAcrylic) return;
    const variant = getAcrylicVariant(state);
    const amount = variant ? money.format(Number(variant.price) / 100) : 'Format indisponible';
    const output = state.card.querySelector('[data-cb-item-price]');
    if (output) output.textContent = amount;
    if (state === states[0] && detailPrice) detailPrice.textContent = amount;
  }
  function getPuzzleVariant(state) {
    if (!state.piecesSelect) return null;
    return puzzleVariants.find(variant => String(variant.pieces) === state.piecesSelect.value && variant.available);
  }
  function updatePuzzleVariant(state) {
    if (!isPuzzle) return;
    const variant = getPuzzleVariant(state);
    const amount = variant ? money.format(Number(variant.price) / 100) : 'Format indisponible';
    const output = state.card.querySelector('[data-cb-item-price]');
    if (output) output.textContent = amount;
    if (state === states[0] && detailPrice) detailPrice.textContent = amount;
  }
  function getPlaidVariant(state) {
    if (!state.colorSelect || !state.sizeSelect) return null;
    return plaidVariants.find(v => String(v.color) === state.colorSelect.value && String(v.size) === state.sizeSelect.value && v.available);
  }
  function updatePlaidVariant(state) {
    if (!isPlaid) return;
    const variant = getPlaidVariant(state);
    const amount = variant ? money.format(Number(variant.price) / 100) : 'Option indisponible';
    const output = state.card.querySelector('[data-cb-item-price]');
    if (output) output.textContent = amount;
    if (state === states[0]) {
      if (detailPrice) detailPrice.textContent = amount;
      showPlaidColor(state.colorSelect.value);
    }
  }
  const addUrl = root.dataset.addUrl || '/cart/add.js';
  const container = root.querySelector('[data-cb-projects]');
  const firstCard = root.querySelector('[data-cb-project]');
  const template = firstCard.cloneNode(true);
  const quantityLabel = root.querySelector('[data-cb-quantity]');
  const minus = root.querySelector('[data-cb-minus]');
  const plus = root.querySelector('[data-cb-plus]');
  const states = [];
  let busy = false;

  function newProjectId() {
    if (crypto.randomUUID) return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  async function readPhoto(file) {
    if (typeof createImageBitmap === 'function') {
      try {
        return await createImageBitmap(file);
      } catch (_) {}
    }
    const url = URL.createObjectURL(file);
    try {
      const image = new Image();
      image.src = url;
      await new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = () => reject(new Error('Photo illisible. Utilisez un fichier JPG, PNG ou WebP.'));
      });
      return {
        width: image.naturalWidth,
        height: image.naturalHeight,
        close: () => URL.revokeObjectURL(url),
        image
      };
    } catch (error) {
      URL.revokeObjectURL(url);
      throw error;
    }
  }

  async function preparePhoto(file, index) {
    const bitmap = await readPhoto(file);
    const source = bitmap.image || bitmap;
    if (bitmap.width * bitmap.height > 60000000) {
      bitmap.close();
      throw new Error('Une photo est trop grande. Exportez-la avec une résolution inférieure.');
    }
    const scale = Math.min(1, (isPuzzle ? 4000 : 2400) / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const context = canvas.getContext('2d');
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(source, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise((resolve, reject) => canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Photo illisible.')), 'image/jpeg', 0.9));
    if (blob.size > (isPuzzle ? 8 : 3) * 1024 * 1024) throw new Error('Photo trop lourde après préparation. Choisissez une image plus petite.');
    const prepared = new File([blob], `photo-${index + 1}.jpg`, {type: 'image/jpeg'});
    return {file: prepared, url: URL.createObjectURL(prepared)};
  }


  function createCard(card, number) {
    const fileInput = card.querySelector('[data-cb-file]');
    const uploadTitle = card.querySelector('[data-cb-upload-title]');
    const uploadCount = card.querySelector('[data-cb-upload-count]');
    const messageInput = card.querySelector('[data-cb-message]');
    const nameOneInput = card.querySelector('[data-cb-name-one]');
    const nameTwoInput = card.querySelector('[data-cb-name-two]');
    const colorSelect = card.querySelector('[data-cb-color]');
    const sizeSelect = card.querySelector('[data-cb-size]');
    const piecesSelect = card.querySelector('[data-cb-pieces]');
    const counter = card.querySelector('[data-cb-counter]');
    const previewMessage = card.querySelector('[data-cb-preview-message]');
    const consentButton = card.querySelector('[data-cb-consent]');
    const saveButton = card.querySelector('[data-cb-save]');
    const errorBox = card.querySelector('[data-cb-error]');
    const successBox = card.querySelector('[data-cb-success]');
    const slots = [...card.querySelectorAll('[data-cb-slot]')];
    const form = card.querySelector('[data-cb-form]');
    const state = {card, photos: [], added: false, projectId: newProjectId()};
    card.querySelector('[data-cb-project-title]').textContent = `Exemplaire ${number}`;
    if (number > 1) {
      card.querySelector('#personnaliser')?.removeAttribute('id');
      const consentLabel = card.querySelector('.consent label');
      consentButton.id = `photo-consent-${number}`;
      consentLabel.setAttribute('for', consentButton.id);
      consentButton.setAttribute('aria-checked', 'false');
      consentButton.dataset.state = 'unchecked';
      consentButton.replaceChildren();
      fileInput.value = '';
      messageInput.value = '';
      if (nameOneInput) nameOneInput.value = '';
      if (nameTwoInput) nameTwoInput.value = '';
      if (colorSelect) colorSelect.value = 'Noir';
      if (sizeSelect) sizeSelect.value = isAcrylic ? '8 x 8 cm' : '100 x 150 cm';
      if (piecesSelect) piecesSelect.value = '300 pièces';
      successBox.hidden = true;
      errorBox.hidden = true;
      saveButton.hidden = true;
      card.querySelector('.small-note').hidden = true;
    }
    state.consent = false;
    function showError(message) {
      errorBox.textContent = message;
      errorBox.hidden = !message;
      if (message) errorBox.scrollIntoView({block: 'nearest'});
    }
    function invalidate() {
      if (state.added) return;
      state.projectId = newProjectId();
      successBox.hidden = true;
      if (number === 1) saveButton.hidden = false;
    }
    function renderPhotos() {
      slots.forEach((slot, index) => {
        const photo = state.photos[index];
        slot.replaceChildren();
        if (!photo) {
          const holder = document.createElement('div');
          holder.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect><circle cx="9" cy="9" r="2"></circle><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path></svg>';
          holder.append(document.createTextNode(`Photo ${index + 1}`));
          slot.append(holder);
          return;
        }
        const image = document.createElement('img');
        image.src = photo.url;
        image.alt = `Votre photo ${index + 1} de l’exemplaire ${number}`;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'remove-photo';
        remove.setAttribute('aria-label', `Supprimer la photo ${index + 1} de l’exemplaire ${number}`);
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          if (busy || state.added) return;
          URL.revokeObjectURL(photo.url);
          state.photos.splice(index, 1);
          invalidate();
          renderPhotos();
        });
        slot.append(image, remove);
      });
      uploadCount.textContent = `${state.photos.length}/${photoCount} ajoutée${state.photos.length > 1 ? 's' : ''} · JPG, PNG ou WebP · 10 Mo maximum par photo`;
    }
    fileInput.addEventListener('change', async () => {
      const selected = [...fileInput.files];
      fileInput.value = '';
      if (!selected.length || busy || state.added) return;
      showError('');
      if (state.photos.length + selected.length > photoCount) {
        showError(`Choisissez ${photoCount} photo${photoCount > 1 ? 's' : ''} pour cet exemplaire. Supprimez une photo pour la remplacer.`);
        return;
      }
      if (selected.some(file => !['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024)) {
        showError('Utilisez des fichiers JPG, PNG ou WebP de 10 Mo maximum. Sur iPhone, exportez les HEIC en JPEG.');
        return;
      }
      busy = true;
      updateBusy();
      const prepared = [];
      try {
        for (const file of selected) prepared.push(await preparePhoto(file, state.photos.length + prepared.length));
        state.photos.push(...prepared);
        invalidate();
        renderPhotos();
      } catch (error) {
        prepared.forEach(photo => URL.revokeObjectURL(photo.url));
        showError(error instanceof Error ? error.message : 'Impossible de lire cette photo.');
      } finally {
        busy = false;
        updateBusy();
      }
    });
    function previewText() {
      if (isPlaid) {
        counter.textContent = messageInput.value.length + '/30 caractères';
        const names = [nameOneInput.value.trim(), nameTwoInput.value.trim()].filter(Boolean).join(' & ');
        previewMessage.textContent = [messageInput.value.trim(), names].filter(Boolean).join(' · ') || 'Votre histoire commence ici.';
      } else {
        counter.textContent = isKeychain ? messageInput.value.length + '/50 caractères' : messageInput.value.length + '/80 caractères' + (isAcrylic ? '' : ' · demande à confirmer sur le modèle final');
        previewMessage.textContent = messageInput.value || 'Votre histoire commence ici.';
      }
      invalidate();
    }
    messageInput.addEventListener('input', previewText);
    if (isAcrylic) sizeSelect.addEventListener('change', () => { invalidate(); updateAcrylicVariant(state); });
    if (isPuzzle) piecesSelect.addEventListener('change', () => {
      invalidate();
      updatePuzzleVariant(state);
    });
    if (isPlaid) {
      [nameOneInput, nameTwoInput].forEach(input => input.addEventListener('input', previewText));
      [colorSelect, sizeSelect].forEach(select => select.addEventListener('change', () => {
        invalidate();
        updatePlaidVariant(state);
      }));
    }
    consentButton.addEventListener('click', () => {
      if (busy || state.added) return;
      state.consent = !state.consent;
      consentButton.setAttribute('aria-checked', String(state.consent));
      consentButton.dataset.state = state.consent ? 'checked' : 'unchecked';
      consentButton.innerHTML = state.consent ? '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>' : '';
    });
    form.addEventListener('submit', event => { event.preventDefault(); if (number === 1) void addAll(); });
    renderPhotos();
    return Object.assign(state, {fileInput, uploadTitle, messageInput, nameOneInput, nameTwoInput, colorSelect, sizeSelect, piecesSelect, consentButton, saveButton, errorBox, successBox, showError});
  }

  function updateQuantity() {
    quantityLabel.value = String(states.length);
    quantityLabel.textContent = String(states.length);
    minus.disabled = busy || states.length === 1 || states.some(state => state.added);
    plus.disabled = busy || states.length >= 10 || states.some(state => state.added);
  }
  function updateBusy() {
    states.forEach(state => {
      state.fileInput.disabled = busy || state.added;
      state.messageInput.disabled = busy || state.added;
      if (state.nameOneInput) state.nameOneInput.disabled = busy || state.added;
      if (state.nameTwoInput) state.nameTwoInput.disabled = busy || state.added;
      if (state.colorSelect) state.colorSelect.disabled = busy || state.added;
      if (state.sizeSelect) state.sizeSelect.disabled = busy || state.added;
      if (state.piecesSelect) state.piecesSelect.disabled = busy || state.added;
      state.consentButton.disabled = busy || state.added;
      state.uploadTitle.textContent = busy ? 'Préparation en cours…' : photoCount > 1 ? 'Importer mes photos' : 'Importer ma photo';
    });
    states[0].saveButton.disabled = busy;
    states[0].saveButton.textContent = busy ? 'Enregistrement en cours…' : 'Ajouter au panier avec mes photos';
    updateQuantity();
  }
  async function addAll() {
    if (busy) return;
    for (let index = 0; index < states.length; index++) {
      const state = states[index];
      state.showError('');
      if (state.added) continue;
      if (state.photos.length !== photoCount) {
        state.showError(`Ajoutez ${photoCount === 1 ? 'la photo' : `les ${photoCount} photos`} de l’exemplaire ${index + 1}.`);
        return;
      }
      if (isKeychain && !state.messageInput.value.trim()) {
        state.showError('Indiquez le texte personnalisé de l’exemplaire ' + (index + 1) + '.');
        return;
      }
      if (isAcrylic && (!getAcrylicVariant(state) || !state.messageInput.value.trim())) {
        state.showError('Choisissez le format et indiquez le message de l’exemplaire ' + (index + 1) + '.');
        return;
      }
      if (isPuzzle && !getPuzzleVariant(state)) {
        state.showError('Choisissez le nombre de pièces de l’exemplaire ' + (index + 1) + '.');
        return;
      }
      if (isPlaid && (!getPlaidVariant(state) || !state.messageInput.value.trim() || !state.nameOneInput.value.trim() || !state.nameTwoInput.value.trim())) {
        state.showError('Choisissez la couleur, la taille, le titre et les deux prénoms de l’exemplaire ' + (index + 1) + '.');
        return;
      }
      if (!state.consent) {
        state.showError(`Confirmez l’accord pour les photos de l’exemplaire ${index + 1}.`);
        return;
      }
    }
    if (!variantId) { states[0].showError('La référence Shopify ne peut pas être chargée. Rechargez cet aperçu.'); return; }
    busy = true;
    updateBusy();
    try {
      for (let index = 0; index < states.length; index++) {
        const state = states[index];
        if (state.added) continue;
        const data = new FormData();
        data.set('id', isPlaid ? getPlaidVariant(state).id : isPuzzle ? getPuzzleVariant(state).id : isAcrylic ? getAcrylicVariant(state).id : variantId);
        data.set('quantity', '1');
        data.set('properties[_Projet Click & Booth]', state.projectId);
        if (isPlaid) {
          data.set('properties[Titre de la chanson]', state.messageInput.value.trim());
          data.set('properties[Prénom 1]', state.nameOneInput.value.trim());
          data.set('properties[Prénom 2]', state.nameTwoInput.value.trim());
        } else if (isAcrylic) {
          data.set('properties[Message personnalisé]', state.messageInput.value.trim());
        } else if (isKeychain) {
          data.set('properties[Texte personnalisé 1]', state.messageInput.value.trim());
        } else if (!isPuzzle && !isPhotoOnly) {
          data.set('properties[Quelques mots à garder]', state.messageInput.value);
        }
        data.set('properties[_Consentement photo]', 'oui');
        state.photos.forEach((photo, photoIndex) => data.set(`properties[Photo ${photoIndex + 1}]`, photo.file));
        const response = await fetch(addUrl, {method: 'POST', body: data, credentials: 'same-origin', headers: {Accept: 'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(`Exemplaire ${index + 1} : ${result.description || 'Shopify ne répond pas.'}`);
        const received = Array.from({length: photoCount}, (_, photoIndex) => result.properties?.[`Photo ${photoIndex + 1}`]);
        if (!result.key || received.some(url => !url || (!url.startsWith('//cdn.shopify.com/') && !url.startsWith('https://cdn.shopify.com/')))) {
          throw new Error(`Exemplaire ${index + 1} : Shopify n’a pas confirmé toutes les photos. Vérifiez le panier avant de réessayer.`);
        }
        state.added = true;
      }
      states[0].successBox.hidden = false;
      states[0].saveButton.hidden = true;
    } catch (error) {
      const pending = states.filter(state => !state.added).length;
      states[0].showError(`${error instanceof Error ? error.message : 'Enregistrement impossible.'} ${states.length - pending} exemplaire(s) confirmé(s) au panier ; réessayez pour les ${pending} restant(s) seulement.`);
    } finally {
      busy = false;
      updateBusy();
    }
  }
  states.push(createCard(firstCard, 1));
  if (isPlaid) updatePlaidVariant(states[0]);
  if (isPuzzle) updatePuzzleVariant(states[0]);
  if (isAcrylic) updateAcrylicVariant(states[0]);
  const actions = document.createElement('div');
  actions.className = 'cb-project-actions';
  const primaryForm = firstCard.querySelector('[data-cb-form]');
  actions.append(primaryForm.querySelector('[data-cb-error]'), primaryForm.querySelector('[data-cb-success]'), primaryForm.querySelector('[data-cb-save]'), primaryForm.querySelector('.small-note'));
  container.after(actions);
  states[0].saveButton.addEventListener('click', () => { void addAll(); });
  plus.addEventListener('click', () => {
    if (busy || states.length >= 10 || states.some(state => state.added)) return;
    const clone = template.cloneNode(true);
    container.append(clone);
    states.push(createCard(clone, states.length + 1));
    if (isPlaid) updatePlaidVariant(states[states.length - 1]);
    if (isPuzzle) updatePuzzleVariant(states[states.length - 1]);
    if (isAcrylic) updateAcrylicVariant(states[states.length - 1]);
    states[0].successBox.hidden = true;
    states[0].saveButton.hidden = false;
    updateQuantity();
  });
  minus.addEventListener('click', () => {
    if (busy || states.length === 1 || states.some(state => state.added)) return;
    const state = states.pop();
    state.photos.forEach(photo => URL.revokeObjectURL(photo.url));
    state.card.remove();
    updateQuantity();
  });
  window.addEventListener('pagehide', () => states.forEach(state => state.photos.forEach(photo => URL.revokeObjectURL(photo.url))), {once: true});
  updateQuantity();
})();
